export class EntreprisesFilters {
	
	nom: string = "";
	actif: boolean | null = true;	
	selectedAntenneIds!: number[];
	documentApplicable: string | null = null;

	constructor() {
	}
}